<ng-template>
  <div class="carousel-slide-content-wrapper">
    <ng-content></ng-content>
  </div>
</ng-template>
